import React from 'react';

interface Milestone {
  _id?: string;
  id?: string;
  title: string;
  status?: string;
}

interface GoalMilestoneBadgeProps {
  milestone: Milestone;
  className?: string;
}

const GoalMilestoneBadge: React.FC<GoalMilestoneBadgeProps> = ({ milestone, className = '' }) => {
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-1 bg-blue-50 text-blue-700 text-xs rounded ${className}`}>
      <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
        />
      </svg>
      Connected to Milestone: {milestone.title}
      {milestone.status && <span className="ml-1">({milestone.status})</span>}
    </span>
  );
};

export default GoalMilestoneBadge;

